import React from "react"
import {
  FaFacebook,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
} from "react-icons/fa"

const SocialData = [
  { link: "https://www.facebook.com", icon: <FaFacebook /> },
  { link: "https://www.twitter.com", icon: <FaTwitter /> },
  { link: "https://www.linkedin.com", icon: <FaLinkedinIn /> },
  { link: "https://www.instagram.com", icon: <FaInstagram /> },
]

export default SocialData
